import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import SEOHead from '@/components/base/SEOHead';
import BrandIntro from './components/BrandIntro';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';

export default function AboutPage() {
  const schemaData = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '一起草每日大赛',
      url: 'https://williamallen.cn',
      description: '一起草每日大赛是专为草类竞技爱好者打造的每日在线赛事平台',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        telephone: '400-888-9999',
        email: 'contact@williamallen.cn',
        availableLanguage: ['Chinese'],
        hoursAvailable: [
          {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
            opens: '09:00',
            closes: '21:00',
          },
        ],
      },
      address: {
        '@type': 'PostalAddress',
        streetAddress: '体育产业园A座1208室',
        addressLocality: '北京',
        addressRegion: '朝阳区',
        addressCountry: '中国',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '关于我们 - 一起草每日大赛',
      description: '了解一起草每日大赛的品牌故事、用户口碑和联系方式。一起草是专为草类竞技爱好者打造的每日在线赛事平台。',
      url: 'https://williamallen.cn/about',
      isPartOf: {
        '@type': 'WebSite',
        name: '一起草每日大赛',
        url: 'https://williamallen.cn',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: 'https://williamallen.cn' },
        { '@type': 'ListItem', position: 2, name: '关于我们' },
      ],
    },
  ];

  return (
    <>
      <SEOHead
        title="关于我们 - 一起草每日大赛 | 品牌介绍与联系方式"
        description="了解一起草每日大赛的品牌故事、企业使命和核心优势。一起草是国内首个专注于草类竞技的每日在线赛事平台，覆盖全国32个城市，服务超过50,000名注册选手。"
        keywords="一起草每日大赛,关于一起草,草类竞技平台,一起草品牌,联系我们"
        canonicalUrl="https://williamallen.cn/about"
        schemaData={schemaData}
      />
      <Navbar />
      <main className="pt-16">
        <div className="w-full max-w-5xl mx-auto px-4 md:px-6 pb-16">
          <Breadcrumb />
          <BrandIntro />
          <Testimonials />
          <Contact />
        </div>
      </main>
      <Footer />
    </>
  );
}